import { render, staticRenderFns } from "./ProductBundles.vue?vue&type=template&id=30c407e0"
import script from "./ProductBundles.vue?vue&type=script&lang=js"
export * from "./ProductBundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports